import { DeleteButton } from '../../../components/DeleteButton';
import { EditButton } from '../../../components/EditButton';

export const ContactEntry = ({ contact, handleDelete, handleEdit }) => {
       
    return (
        <tr>
            <td className="align-left">
                {contact.name}
            </td>
            <td className="align-left">
                +{contact.mobilePhoneNumber}
            </td>
            <td className="align-middle">
                <DeleteButton className="float-right mr-1" tooltip="Delete" onClick={() => handleDelete(contact)} />
                <EditButton className="float-right mr-1" tooltip="Edit" onClick={() => handleEdit(contact)} />                
            </td>
        </tr>
    )
}